import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash"
import {PlanningRouteOverviewSettingsModel} from "../../models/planning-route-overview-settings.model";
import {PlanningCommonService} from "../../services/planning-coomon-service.service";

export class PlanningRouteOverviewCtrl implements IController {
  route: any;
  resource: any;
  draft?: any;
  jobs: any;
  depots: any;
  onClose: Function;

  public planningRouteOverviewSettings: PlanningRouteOverviewSettingsModel;
  public dateRange: any;
  public routeColor: any;
  public siteId: string

  private volumeUnit: any;
  private weightUnit: any;

  /* @ngInject */
  constructor(private planningCommonService: PlanningCommonService, private splitService) {
    this.weightUnit = splitService.getWeightUnit();
    this.volumeUnit = splitService.getVolumeUnit();
  }

  $onInit() {
    this.setDateRange();
    this.setRouteColor();
    this.siteId = this.splitService.getSiteId();
    this.planningRouteOverviewSettings = this.splitService.getSitePlanningRouteOverviewSettings(this.siteId) as PlanningRouteOverviewSettingsModel;
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.route && !onChangesObj.route.isFirstChange()) {
      this.setDateRange();
      this.setRouteColor();
    }
  }

  onViewSettingsChange(settings: PlanningRouteOverviewSettingsModel) {
    this.splitService.setSitePlanningRouteOverviewSettings(settings);
    this.planningRouteOverviewSettings = angular.copy(settings);
  }

  getTotalIncomeClass(totalIncome?) {
    const minimumRouteIncome = this.resource?.routeIncomePreferences?.minimumRouteIncome || this.draft?.settings?.incomeSettings?.minRouteIncome;
    const maximumRouteIncome = this.resource?.routeIncomePreferences?.maximumRouteIncome || this.draft?.settings?.incomeSettings?.maxRouteIncome;
    return (!!minimumRouteIncome && (totalIncome < minimumRouteIncome)) ? 'low' :
      ((!!maximumRouteIncome && (totalIncome > maximumRouteIncome)) ? 'high' : '');
  }

  private setDateRange() {
    this.dateRange = {
      from: _.get(_.head(this.route.activities), 'eta'),
      to: _.get(_.last(this.route.activities), 'eta')
    }
  }

  private setRouteColor() {
    this.routeColor = this.planningCommonService.getRouteColor(this.route);
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningRouteOverview', {
    bindings: {
      route: '<',
      resource: '<?',
      draft: '<?',
      jobs: '<',
      depots: '<',
      onClose: '&'
    },
    template: require('./planning-route-overview.html').default,
    controller: PlanningRouteOverviewCtrl
  });
